"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _layoutGridUtils = require("./_layoutGridUtils");

var _layoutGrid = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/layout-grid.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _layoutGrid.default);

var Column = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _classnames;

  var children = _ref.children,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      full = _ref.full,
      offset = _ref.offset,
      offsetPosition = _ref.offsetPosition,
      span = _ref.span,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "cssNamespace", "full", "offset", "offsetPosition", "span"]);
  var offsets = (0, _layoutGridUtils.mapSize)(function (size) {
    return (0, _layoutGridUtils.resolveSpan)(offset, size, false);
  });
  var offsetPositionModifier = offsetPosition === 'after' ? '-after' : '';
  var responsiveColClasses = (0, _layoutGridUtils.mapSizeClasses)(function (size) {
    if ((0, _layoutGridUtils.validSpan)(span)) return span;
    if (span && (0, _layoutGridUtils.validSpan)(span[size])) return span[size];
    return false;
  }, cssNamespace);
  var colClasses = classnames("".concat(cssNamespace, "-col"), responsiveColClasses, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-col--full"), full), (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(cssNamespace, "-col--offset")).call(_context2, offsetPositionModifier, "-")).call(_context, offsets.smallScreen), offsets.smallScreen), (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(cssNamespace, "-col-md--offset")).call(_context4, offsetPositionModifier, "-")).call(_context3, offsets.mediumScreen), offsets.mediumScreen), (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context5 = (0, _concat.default)(_context6 = "".concat(cssNamespace, "-col-lg--offset")).call(_context6, offsetPositionModifier, "-")).call(_context5, offsets.largeScreen), offsets.largeScreen), (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context7 = (0, _concat.default)(_context8 = "".concat(cssNamespace, "-col-xl--offset")).call(_context8, offsetPositionModifier, "-")).call(_context7, offsets.xLargeScreen), offsets.xLargeScreen), _classnames), className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: colClasses,
    ref: ref
  }), children);
});

Column.displayName = 'Column';
process.env.NODE_ENV !== "production" ? Column.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to `true` to have the column automatically occupy the remaining space in the row */
  full: _propTypes.default.bool,

  /** How many cells out of 12 should the column be offset by on each screen size. Defaults to none.
   *
   * Example usage:
   *
   * * `offset={4}` -for all screen sizes
   * * `offset={{ smallScreen: 8}}` -for small screen sizes only, none for other sizes
   * * `offset={{ smallScreen: 6, xLargeScreen: 1}}` -so on
   * * `offset={{ smallScreen: 6, mediumScreen: 5, largeScreen: 3, xLargeScreen: 1}}` -so forth
  */
  offset: _CustomPropTypes.default.validColumnProp,

  /** Are the offsets to be applied `before` or `after` the column? */
  offsetPosition: _propTypes.default.oneOf(['after', 'before']),

  /** How many cells out of 12 should the column occupy on each screen size. Defaults to 12.
   *
   * Example usage:
   *
   * * `span={4}` -for all screen sizes
   * * `span={{ smallScreen: 8}}` -for small screen sizes only, none for other sizes
   * * `span={{ smallScreen: 6, xLargeScreen: 1}}` -so on
   * * `span={{ smallScreen: 6, mediumScreen: 5, largeScreen: 3, xLargeScreen: 1}}` -so forth
  */
  span: _CustomPropTypes.default.validColumnProp
} : void 0;
Column.defaultProps = {
  offsetPosition: 'before'
};

var _default = (0, _withStyles.default)(Column);

exports.default = _default;